<template>
    <BasicTabs :model-value="currentTab">
        <BasicTabHeader value="upcoming">
            {{ translations.upcoming }}
        </BasicTabHeader>
        <BasicTabHeader value="past">
            {{ translations.past }}
        </BasicTabHeader>
        <EventsListsUpcomingEvents value="upcoming"></EventsListsUpcomingEvents>
        <EventsListsPastEvents value="past"></EventsListsPastEvents>
    </BasicTabs>
</template>

<script setup lang="ts">
import BasicTabHeader from '@molecules/BasicTabs/BasicTabHeader.vue';
import BasicTabs from '@molecules/BasicTabs/BasicTabs.vue';
import { useI18n } from '#imports';

const EventsListsUpcomingEvents = defineAsyncComponent(
    () => import('@organisms/EventsLists/EventsListsUpcomingEvents.vue')
);

const EventsListsPastEvents = defineAsyncComponent(
    () => import('@organisms/EventsLists/EventsListsPastEvents.vue')
);

const { query } = useRoute();
const currentTab = ref((query.tab as string) || 'upcoming');

const { t } = useI18n();
const translations = computed(() => ({
    upcoming: t('atp.tabs.upcoming_events'),
    past: t('atp.tabs.past_events'),
}));
</script>

<style scoped>
:deep(.basic-tabs-headers) {
    @apply bg-background-1 rounded-t-[10px] mb-0 border-b border-lines-1;
}

:deep(.basic-tab-header:not(.active, :hover)) {
    @apply border-b-transparent;
}
</style>
